import Button from 'components/button';
import './styles.scss';
import DATA from 'utils/data.json';

const ADVISE_DATA = DATA.advise;

const Advise = () => {
    return (
        <div className="advise">
            <p className="title">{ADVISE_DATA.title}</p>
            <img alt='' src={ADVISE_DATA.icon} className='icon' />
            <p className="sub-title">{ADVISE_DATA.subTitle}</p>
            <p className="text">{ADVISE_DATA.text}</p>
            <Button href={ADVISE_DATA.href} className="cta" content={ADVISE_DATA.cta} />
        </div>
    )
}

export default Advise;